import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from 'mbs-ui-kit';
import { DateTimeFormatComponent } from 'mbs-ui-shared@components/date-time-format/date-time-format.component';
import { SummaryComputersModule } from 'mbs-ui-shared@modules/summary-computers/summary-computers.module';

import { RmmDateTimeFormatComponent } from './rmm-date-time-format.component';

@NgModule({
  imports: [CommonModule, SummaryComputersModule, NgbTooltipModule, LoaderComponent, RmmDateTimeFormatComponent, DateTimeFormatComponent],
  exports: [RmmDateTimeFormatComponent, DateTimeFormatComponent]
})
export class RmmDateTimeFormatModule {}
